"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SnackCategories", {
  enumerable: true,
  get: function () {
    return _notifications.CATEGORIES;
  }
});
exports.updateSnack = exports.setToast = exports.setSnack = exports.clearSnack = void 0;
var _notifications = require("../constants/notifications");
var _actions = require("../actions");
var _configureStore = _interopRequireDefault(require("../store/configureStore"));
var _toasts = require("../services/toasts");
var _auth = require("../utils/auth");
const setToast = options => {
  _configureStore.default.instance.dispatch({
    type: _actions.SET_TOAST,
    payload: (0, _toasts.buildToast)(options),
    meta: {
      callback: options.callback,
      icon: options.icon
    }
  });
};
exports.setToast = setToast;
const setSnack = options => {
  _configureStore.default.instance.dispatch({
    type: _actions.SET_SNACK,
    payload: {
      ID: options.id || (0, _auth.randomString)(16),
      testId: options.testId,
      text: options.text,
      category: options.category,
      actions: options.actions,
      delay: options.delay,
      target: _notifications.TARGETS.INTERNAL
    }
  });
};
exports.setSnack = setSnack;
const updateSnack = options => {
  _configureStore.default.instance.dispatch({
    type: _actions.CHANGE_SNACK,
    payload: options
  });
};
exports.updateSnack = updateSnack;
const clearSnack = ID => {
  updateSnack({
    ID,
    delay: -1
  });
};
exports.clearSnack = clearSnack;